import { List } from 'immutable';
import { parametric, pathSubscription, subscription } from 'nike-re-framejs';

export const top5sports$ = pathSubscription(['market-statistics', 'top-ranking', 'top5sports']);

export const topRankingLoaded$ = pathSubscription(['market-statistics', 'top-ranking', 'loaded']);
export const top5Tournaments$ = pathSubscription(['market-statistics', 'top-ranking', 'top5tournaments'], List());

export const top5BySportId$ = parametric(sportId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5sports', `${sportId}`, 'topEvents'], List())
);

export const top5TournamentNameById$ = parametric(tournamentId =>
    subscription(
        matches => matches?.first()?.get('tournamentName'),
        pathSubscription(['market-statistics', 'top-ranking', 'top5tournamentMatches', `${tournamentId}`])
    )
);

export const top5TournamentSportId$ = parametric(tournamentId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5tournaments', `${tournamentId}`, 'sportId'])
);

export const top5MatchesByTournamentId$ = parametric(tournamentId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5tournamentMatches', `${tournamentId}`])
);

export const top5SportMatches$ = parametric(sportId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5sportMatches', `${sportId}`])
);

export const top5SportMatchesLoaded$ = parametric(sportId =>
    subscription(matches => matches?.size, top5SportMatches$(sportId))
);

export const top5TournamentsLoaded$ = pathSubscription(
    ['market-statistics', 'top-ranking', 'tournamentsLoaded'],
    false
);

export const top5CmsTournamentsLoaded$ = pathSubscription(
    ['market-statistics', 'top-ranking', 'cmsTournamentsLoaded'],
    false
);

export const top5MatchById$ = parametric((sportId, matchId) =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5sportMatches', `${sportId}`, `${matchId}`])
);

export const top5MatchByTournamentId$ = parametric((tournamentId, matchId) =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5tournamentMatches', `${tournamentId}`, `${matchId}`])
);

export const top5TournamentsWithMatches$ = pathSubscription(
    ['market-statistics', 'top-ranking', 'top5tournamentMatches'],
    null
);

export const top5SportsWithMatches$ = pathSubscription(['market-statistics', 'top-ranking', 'top5sportMatches'], null);

export const top5tournamentsIds$ = pathSubscription(['market-statistics', 'top-ranking', 'top5tournamentsIds']);

export const top5BetById$ = parametric(betId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5bets', `${betId}`])
);

export const top5BetIdByMatchId$ = parametric(matchId =>
    subscription(
        bets => bets?.find(b => b?.get('sportEventId') === `${matchId}`),
        pathSubscription(['market-statistics', 'top-ranking', 'top5bets'])
    )
);

export const top10ActiveTab$ = pathSubscription(['market-statistics', 'top-ranking', 'top10ActiveTab']);

// Prematch
export const top10PrematchBets$ = pathSubscription(['market-statistics', 'top-ranking', 'top10', 'bets']);
export const top10PrematchMatches$ = pathSubscription(['market-statistics', 'top-ranking', 'top10', 'matches'], false);
export const top10PrematchMatch$$ = parametric(matchId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top10', 'matches', `${matchId}`], false)
);

// Live
export const top10LiveBets$ = pathSubscription(['market-statistics', 'top-ranking', 'top10Live', 'bets']);
export const top10LiveMatches$ = pathSubscription(['market-statistics', 'top-ranking', 'top10Live', 'matches'], false);
export const top10LiveMatch$$ = parametric(matchId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top10Live', 'matches', `${matchId}`], false)
);

export const top10LiveScoreboard$$ = parametric(matchId => {
    return pathSubscription(
        ['market-statistics', 'top-ranking', 'top10Live', 'matches', `${matchId}`, 'score'],
        List()
    );
});

export const top10LiveMatchStats$$ = parametric(matchId => {
    return pathSubscription(
        ['market-statistics', 'top-ranking', 'top10Live', 'matches', `${matchId}`, 'stats'],
        List()
    );
});

export const top10LiveTimer$$ = parametric(matchId => {
    return pathSubscription(
        ['market-statistics', 'top-ranking', 'top10Live', 'matches', `${matchId}`, 'timer'],
        List()
    );
});

export const top10LiveMatchScoreboardType$$ = parametric(matchId =>
    pathSubscription([
        'market-statistics',
        'top-ranking',
        'top10Live',
        'matches',
        `${matchId}`,
        'extras',
        'scoreboardType'
    ])
);

export const top10LiveBetSelection$$ = parametric((betId, code) =>
    subscription(
        selections => selections?.find(selection => selection.get('code') === code),
        pathSubscription(['market-statistics', 'top-ranking', 'top10Live', 'betsLive', `${betId}`, 'selections'])
    )
);

export const isTop10LiveLoaded$ = pathSubscription(
    ['market-statistics', 'top-ranking', 'top10Live', 'betsLive'],
    false
);

export const isHomepageInfocentrumSet$ = pathSubscription(
    ['market-statistics', 'top-ranking', 'infocentrumSet'],
    false
);

export const tournamentShowAllBets$$ = parametric(tournamentId =>
    pathSubscription(['market-statistics', 'top-ranking', 'top5tournaments', `${tournamentId}`, 'showAll'], false)
);
